import roles from 'User/constants/roles';

const mapUserToOption = user => ({
    value: user.id,
    label: `${user.lastName}, ${user.firstName}`,
    isManager: user.role === roles.MANAGER,
});

export default mapUserToOption;
